import { SupportFooter } from "../../../../src/components/SupportFooter";
import * as React from 'react';
export default {
  SupportFooter,
  React
};